import React from "react";

const Intro = () => {
  return (
    <div className="tool__intro">
      <h4 className="tool__header">Your Photos/Full Color Art</h4>
      <p>The following file types are IDEAL for upload: PNG, JPEG, and BMP.</p>
      <p>
        Please make sure that your photo is a similar aspect ratio to the
        product it is being place on, and that it is high resolution. The file
        can be up to 8 MB in size.
      </p>
    </div>
  );
};

export default Intro;
